import React, { Component } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { DKLabel, DKButton } from "deskera-ui-library";
import AppManager from "../../managers/AppManager";
import DataGridHolder from "../common/DataGridHolder";
import { TABLES } from "../../managers/TableManger";
import FunnelManager from "./FunnelManager";

export interface IFunnelProps {}
export interface IFunnelState {}
export default class Funnel extends Component<IFunnelProps, IFunnelState> {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    FunnelManager.setFunnelDataFromAPI(null);
  }
  render() {
    return (
      <div className="parent-width">
        {this.getBanner()}
        {this.getDataGrid()}
      </div>
    );
  }
  getBanner = () => {
    return (
      <div className="column bg-deskera-secondary p-r border-radius-m border-m banner-holder">
        <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about creating & managing landing pages.' />

        <div className="row mt-r ml-l">
          <DKButton
            className="border-m bg-white"
            title="Read"
            onClick={AppManager.showComingSoonWarning}
          />
          <DKButton
            className="border-m ml-r bg-white"
            title="Watch"
            onClick={AppManager.showComingSoonWarning}
          />
        </div>
      </div>
    );
  };
  getDataGrid = () => {
    return (
      <div className="column mt-l parent-width mb-xl position-relative ">
        <DataGridHolder
          tableName={TABLES.FUNNEL}
          allowRowEdit={true}
          allowSearch={true}
          allowFilter={true}
          allowColumnAdd={true}
          allowColumnEdit={true}
          onRowEdit={(data) => {
            let data_formatted = {};
            data_formatted["data"] = {
              _id: data.rowData.id,
              cells: data.rowData,
            };
            data_formatted["id"] = data.rowData.id;

            FunnelManager.setFunnelDataFromAPI(data_formatted);
            RouteManager.navigateToPage(
              PAGE_ROUTES.FUNNEL_BUILDER + "/" + data.rowData.id
            );
          }}
          allowRowAdd={true}
          addButtonConfig={{
            title: "+ New Funnel",
            className: "bg-app text-white",
            onClick: () => {
              RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_SELECTION);
            },
          }}
        />
      </div>
    );
  };
}
